export * from "ce/selectors/workspaceSelectors";
import type { DefaultRootState } from "react-redux";

export const getGroupSuggestions = (state: DefaultRootState) => {
  return state.ui.workspaces.groupSuggestions;
};

export const getIsImportingPackage = (state: DefaultRootState) => {
  return state.ui.workspaces.loadingStates.isImportingPackage;
};

export const getImportedPackage = (state: DefaultRootState) => {
  return state.ui.workspaces.importedPackage;
};

export const getCreatePackageModalState = (state: DefaultRootState) => {
  return state.ui.workspaces.createPackageModal;
};
